// In dev we always go through Vite's proxy (same-origin, so cookies Just Work).
// Any VITE_API_URL override only takes effect in production builds.
export const API_URL = import.meta.env.DEV
	? ''
	: (import.meta.env.VITE_API_URL ?? '')
